// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-features-common-styles-___NotFound__NotFound___1G0JL .src-features-common-styles-___NotFound__container___2A8K3{display:flex;flex-direction:column;position:relative}@media print{.src-features-common-styles-___NotFound__NotFound___1G0JL .src-features-common-styles-___NotFound__container___2A8K3{display:block}}\n", ""]);
// Exports
exports.locals = {
	"NotFound": "src-features-common-styles-___NotFound__NotFound___1G0JL",
	"container": "src-features-common-styles-___NotFound__container___2A8K3"
};
module.exports = exports;
